module.exports = __webpack_public_path__ + "img/11.66be475a.png";